import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { GlobalPhoneWhitelistBasic } from '@models/ss-api/responses/global.phone.whitelist.basic';

export interface IAddGlobalPhoneWhitelist {
    Title: string;
}

@Component({
    selector: 'add-global-phone-whitelist-dialog',
    styleUrls: ['./add.global.phone.whitelist.dialog.scss'],
    templateUrl: './add.global.phone.whitelist.dialog.html'
})

export class AddGlobalPhoneWhitelist extends DialogComponent<IAddGlobalPhoneWhitelist, boolean> implements IAddGlobalPhoneWhitelist, OnInit {
    IsBusy: boolean;
    Title: string;
    GlobalPhoneWhitelistBasic: GlobalPhoneWhitelistBasic;

    GlobalPhoneWhitelistForm: FormGroup;

    constructor(private api: ssApiService, dialogService: DialogService, private gb: GlobalService, private sweetAlert: SweetAlertService, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {
        this.IsBusy = false;
        if (!this.GlobalPhoneWhitelistBasic) {
            this.GlobalPhoneWhitelistBasic = new GlobalPhoneWhitelistBasic();
        } else {

        }

        this.GlobalPhoneWhitelistForm = new FormGroup({
            'Phone': new FormControl(this.GlobalPhoneWhitelistBasic.Phone, [Validators.required])
        })
    }

    confirm() {
        console.log("val", this.GlobalPhoneWhitelistForm.valid);
        if (!this.GlobalPhoneWhitelistForm.valid) return false;
        this.IsBusy = true;
        this.result = true;

        let controls = this.GlobalPhoneWhitelistForm.controls;
        let disposable = this.api.AddGlobalPhoneWhitelist(controls['Phone'].value).subscribe(response => {
            if (response.Result) {
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Success!',
                    timer: 1500
                }).then( () => { this.close(); }, () => { this.close(); } )
            }
            disposable.unsubscribe();
        })
    }

}
